import { CmsReactComponent } from 'components/cms/CmsReactComponent';
import { SubscribeProps } from "./types";
import {
    PropertyDefinition
} from "app/library/layout-builder";
import {SubscribePropertyDefinitions} from "../../definitions";

export class SubscribeDefinitions extends CmsReactComponent<SubscribeProps> {

    static schemaName = "subscribe";

    static propertyDefinitions: PropertyDefinition[] = SubscribePropertyDefinitions;


}
